/**
 * KAN-752: включённые операторы канала (кампании рассылки).
 *
 *   GET /api/v1/users/channel-operators/?channel=telegram_user
 *     -> [{id, name, email, is_campaign_operator}]
 *
 * Если операторов канала больше одного, при создании TG-списка (owner_id) и
 * подключении TG-аккаунта (operator_id) кампанию выбирают явно; без выбора
 * бэкенд отвечает 400 {"code": "operator_required"}.
 */
import apiClient from './client';

export interface ChannelOperator {
  id: string;
  name: string;
  email: string;
  is_campaign_operator: boolean;
}

/** Канал рассылки с личных Telegram-аккаунтов. */
export const TELEGRAM_USER_CHANNEL = 'telegram_user';

export const channelOperatorsApi = {
  list: async (channel: string): Promise<ChannelOperator[]> =>
    (
      await apiClient.get<ChannelOperator[]>('/api/v1/users/channel-operators/', {
        params: { channel },
      })
    ).data,
};
